import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Auth from "@hooks/useAuth";
import Message, { PredefinedMessages } from "@hooks/useMessage";
import {
  useUseToggleFavoriteShop_CreateUserFavoriteShopMutation,
  useUseToggleFavoriteShop_DeleteUserFavoriteShopMutation,
} from "@hooks/useToggleFavoriteShop/__generated__/mutations";
import { isOfflineError } from "@libs/apolloClient";
import { paths } from "@libs/paths";

const useToggleFavoriteShop = (
  shopUuid: string | undefined,
  initialIsFavorite: boolean
) => {
  const { addMessage } = Message.useContainer();
  const [isFavorite, setIsFavorite] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const router = useRouter();
  const { isCurrentUserLoggedOut } = Auth.useContainer();

  const [createUserFavoriteShop] =
    useUseToggleFavoriteShop_CreateUserFavoriteShopMutation();

  const [deleteUserFavoriteShop] =
    useUseToggleFavoriteShop_DeleteUserFavoriteShopMutation();

  useEffect(() => {
    setIsFavorite(initialIsFavorite);
  }, [initialIsFavorite]);

  const toggle = async () => {
    if (isBusy || !shopUuid) {
      return;
    }

    if (isCurrentUserLoggedOut) {
      await router.push(paths.login);
      return;
    }

    const firstValue = isFavorite;
    setIsBusy(true);
    setIsFavorite(!firstValue);
    try {
      if (firstValue) {
        await deleteUserFavoriteShop({ variables: { input: { shopUuid } } });
      } else {
        await createUserFavoriteShop({
          variables: { input: { shopUuid } },
        });
      }
    } catch (err) {
      console.error(err);
      isOfflineError(err)
        ? addMessage(PredefinedMessages.offlineError)
        : addMessage(PredefinedMessages.commonError);
      setIsFavorite(firstValue);
      // 500エラーの場合は500エラーの画面遷移をしないように同じ画面に留まるようにする
      router.replace(router.asPath);
    }
    setIsBusy(false);
  };

  return { toggle, isFavorite };
};

export default useToggleFavoriteShop;
